<template>
  <section class="reports">
    <za-banner></za-banner>
    <article class="article">
      <div 
        class="article-item" 
        :class="{'reverse': index == 1}" 
        v-for="(item, index) in features" 
        :key="index">
        <img :src="item.pic" :alt="item.title">
        <div class="article-item-info">
          <h3>{{item.title}}</h3>
          <p>{{item.desc}}</p>
        </div>
      </div>
    </article>
  </section>
</template>

<script>
import zaBanner  from '@/components/Banner.vue'
export default {
  components: {
    zaBanner
  },
  data () {
    return {
      features: [
        {pic: require('../assets/img/phone1-icon.png'), title: '核心业务：软件开发', desc: '公司在软件开发方面表现出色，具备多项独特优势。其定制化开发能力能够根据客户的特定需求和业务流程，打造个性化的软件产品。不仅注重界面风格的独特性和精美度，以吸引用户，还在功能需求上突出企业优势和品牌形象，增强竞争力。'},
        {pic: require('../assets/img/phone2-icon.png'), title: '核心业务：技术服务', desc: '技术服务是公司的核心竞争力之一。拥有专业且经验丰富的技术团队，能够为客户提供全方位、多层次的技术支持。无论是系统升级、故障排查还是数据迁移，都能迅速响应并精准解决。此外，还提供定制化培训服务，帮助客户提升技术能力。'},
      ]
    }
  },
  methods: {
  }
}
</script>
<style scoped>
.article{
  padding: 10% 88px;
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}

.article-item{
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 100px;
}

.article-item img{
  width: 460px;
  border-radius: 50px;
}
.article-item-info {
  width: 500px;
}
.article-item-info h3 {
  font-family: Source Han Sans CN;
  font-weight: 500;
  font-size: 32px;
  color: #333333;
  margin-bottom: 44px;
}
.article-item-info p {
  font-family: Source Han Sans CN;
  font-weight: 400;
  font-size: 20px;
  color: #333333;
  line-height: 30px;
}

.reverse{
  flex-direction: row-reverse;
}
</style>